export const updateCheckedContacts = (ids) => {
    return {
        type : 'UPDATE_CHECKED_CONTACTS',
        payload : {
            ids
        }
    }
}


export const removeContacts = (ids) => {
    return (dispatch, getState, getFirebase) => {

        if(ids == null || ids.length === 0) {
            global.alert('선택한 항목이 없습니다.');

        }
        else {
            const result = global.confirm(`선택한 ${ids.length}개의 항목을 삭제하시겠습니까?`);
            if (result) {
                const firebase = getFirebase();
                ids.map(id => {
                    const contactRef = firebase.ref().child(`contacts/${id}`);
                    contactRef.remove();
                })
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/Admin/ContactManager/actions/contactActions.js